"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _uiIdenticon = _interopRequireDefault(require("@polkadot/ui-identicon"));

// Copyright 2017-2019 @polkadot/ui-keyring authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "KeyPair__Wrapper",
  componentId: "sc-1n5iou1-0"
})(["display:flex;flex-wrap:nowrap;justify-content:space-between;position:relative;white-space:nowrap;> .address{display:inline-block;flex:1;font-family:monospace;margin-left:1rem;opacity:0.5;overflow:hidden;text-align:right;text-overflow:ellipsis;}> .icon{position:absolute;top:-9px;left:0;}> .name{display:inline-block;flex:1 0;margin-left:3rem;overflow:hidden;text-overflow:ellipsis;&.uppercase{text-transform:uppercase;}}"]);

class KeyPair extends _react.default.PureComponent {
  render() {
    const _this$props = this.props,
          address = _this$props.address,
          className = _this$props.className,
          isUppercase = _this$props.isUppercase,
          name = _this$props.name,
          style = _this$props.style;
    return _react.default.createElement(Wrapper, {
      className: ['ui--KeyPair', className].join(' '),
      style: style
    }, _react.default.createElement(_uiIdenticon.default, {
      className: "icon",
      size: 32,
      value: address
    }), _react.default.createElement("div", {
      className: "name ".concat(isUppercase ? 'uppercase' : 'normalcase')
    }, name), _react.default.createElement("div", {
      className: "address"
    }, address));
  }

}

exports.default = KeyPair;